module.exports = __webpack_public_path__ + "static/img/gpt12.569e353a.jpg";